module.exports = __webpack_public_path__ + "static/media/busca.b40d375f.png";